export const marketInsightsEn = {
  marketInsights: {
    nav: {
      citiesList: 'Cities Lists',
      customReporting: 'Custom Reporting',
      defaultSettings: 'Default Settings',
      historicalMarketData: 'Historical Market Data',
      marketComparisonCity: 'Market Comparison (City)',
      marketComparisonNeighbourhood: 'Market Comparison (Neighbourhood FSA)',
      marketData: 'Market Data',
      portfolioComparison: 'Portfolio Comparison',
      settings: 'Settings',
      title: 'Market Insights',
    },
    filters: {
      fsaBasedOnCity: 'FSAs - Based on City Selected',
      fsaMap: {
        mapView: 'Map View',
        checkboxList: 'Checkbox List',
        loadingFsaBoundaries: 'Loading FSA boundaries...',
        noFsaBoundaryData: 'No FSA boundary data available for this city.',
        failedToLoadFsaBoundaryData: 'Failed to load FSA boundary data.',
        legendAvailable: 'Available',
        legendSelected: 'Selected',
      },
      labels: {
        city: 'City',
        fsa: 'FSA',
        neighbourhoodFsas: 'Neighbourhood FSAs',
        province: 'Province',
        propertyType: 'Property Type',
        bedrooms: 'Bedrooms',
        amenities: 'Amenities',
        utilities: 'Utilities',
        ageOfConstruction: 'Age of Construction',
        numberOfStories: 'Number of Stories',
        parkingAvailable: 'Parking Available',
        parkingIncluded: 'Parking Included',
        parkingType: 'Parking Type',
        pets: 'Pets',
        timelineRange: 'Timeline Range',
        properties: 'Properties',
      },
      helpText: {
        singleCityScope: 'Select a single city to scope the Market Insights comparison.',
        upToFourCities: 'Choose up to four cities to compare in this report.',
        ageOfConstructionAvailability: 'The Age of Construction filter is subject to availability based on properties that have been surveyed in each market',
        numberOfStoriesAvailability: 'The Number of Stories filter is subject to availability based on properties that have been surveyed in each market. High Rises are denoted as 13+ stories, Mid-Rise 5-12 stories, and Low-Rise 0-4 stories',
        parkingAvailability: 'Data is only obtained from listings where the parking information is available.',
      },
      headingGroups: {
        portfolioAndMarket: 'Portfolio and Market',
        portfolioOnly: 'Portfolio Only',
        marketOnly: 'Market Only',
      },
      dateOptions: {
        currentMonth: 'Current Month',
        last24Months: 'Last 24 Months',
        last18Months: 'Last 18 Months',
        last12Months: 'Last 12 Months',
        last6Months: 'Last 6 Months',
      },
      ageOfConstruction: {
        post2010: 'Post 2010',
        pre2010: 'Pre 2010',
      },
      numberOfStories: {
        highRise: 'High Rise',
        midRise: 'Mid Rise',
        lowRise: 'Low Rise',
      },
      parkingAvailable: {
        available: 'Parking Available',
        unavailable: 'Parking Unavailable',
      },
      parkingIncluded: {
        included: 'Parking Included',
        notIncluded: 'Parking Not Included',
      },
      parkingType: {
        driveway: 'Driveway',
        electric: 'Electric',
        garage: 'Garage',
        indoor: 'Indoor',
        outdoor: 'Outdoor',
        underground: 'Underground',
        valet: 'Valet',
      },
      propertyTypes: {
        apartment: 'Apartment',
        basement: 'Basement',
        condo: 'Condo',
        house: 'House',
        mainFloor: 'Main Floor',
        multiplex: 'Multiplex',
        townhouse: 'Townhouse',
      },
      utilities: {
        electricity: 'Electricity',
        heat: 'Heat',
        water: 'Water',
      },
      petFriendlyTypes: {
        allowed: 'Pets Allowed',
        refused: 'Pets Refused',
      },
    },
    banners: {
      customReportMessage: 'Get more insights with our additional custom reports, they are tailor-made to suit your business needs.',
      expiredSubsHidden: 'Expired subs are not displayed.',
      lookingForMoreCities: 'Looking for more cities or rental markets? Contact your Rentsync Account Manager.',
      noMarketDataWarning: 'We currently don\'t have any market data for the following markets that you are subscribed to: {markets}.',
      portfolioComparisonAccessMessage: 'You currently only have access to Portfolio Comparison market insights, since you have Promoted Listings. Unlock more detailed data, advanced filters, and additional reports with full access.',
      provincialAccessMessage: 'You currently only have access to provincial-level market insights. Unlock city-level data, advanced filters, and additional reports with full access.',
      requestFullAccess: 'Request Full Access',
      requestReport: 'Request Report',
      setupClientCitiesReminder: 'When setting up a client, please add the list of cities requested.',
      subCitiesAsterisk: 'Cities marked with an asterisk include surrounding sub-cities.',
      wantMoreInsights: 'Want more insights?',
    },
    availableFilters: 'Available Filters',
    learnMoreLink: 'Learn more about the data',
    marketData: {
      title: 'Market Data',
      description: 'This report provides market insights on average rent, average square footage, average rent/square footage, listing volume, commonly listed amenities, rent distribution, square footage distribution, and rent/square footage distribution for active listings in the current month.',
      filtersDescription: 'Select a Province, City, FSAs, Month, Property Types, Amenities, Utilities, Parking Availability and Pet Policy to view desired insights.',
    },
    historicalMarketData: {
      title: 'Historical Market Data',
      description: 'This report provides historical insights on average rent, average square footage, average rent/square footage, and listing volume over time.',
      filtersDescription: 'Select a City, Property Types, Age of Construction, and Number of Stories to view desired insights.',
    },
    portfolioComparison: {
      title: 'Portfolio Comparison',
      description: 'This report provides a comparison of your active listings with active market listings and provides insights on average rent, average square footage, and average rent/square footage.',
      filtersDescription: 'Select a City, FSAs, Property Types, Your Properties, Age of Construction, and Number of Stories to view desired insights.',
    },
    infinityPortfolioComparison: {
      title: 'Portfolio Comparison',
      filtersDescription: 'Select a City, FSAs, Property Types, and Your Properties to view desired insights.',
    },
    jaqlFilters: {
      clientsCities: 'Clients Cities',
      clientsBedrooms: 'Clients Bedrooms',
    },
    marketComparisonCity: {
      title: 'Market Comparison (City)',
      description: 'This report provides a comparison of active listing data between markets and provides insights on average rent, average square footage, and listing volume.',
      filtersDescription: 'Select two Cities or more (up to 4) to view desired insights.',
    },
    marketComparisonNeighbourhood: {
      title: 'Market Comparison (Neighbourhood FSA)',
      description: 'This report provides a comparison of active listing data between neighbourhoods and provides insights on the average rent, average square footage, and listing volume. Neighbourhoods are based on FSA - the first three characters of a postal code.',
      filtersDescription: 'Select two Neighbourhoods or more (up to 4) to view desired insights.',
    },
    defaultSettings: {
      header: 'Default Settings',
      description: 'Choose the default city and neighbourhood for default data on the Market Insights dashboards.',
      descriptionNote: 'This will only set the default data, you will have the ability to further edit city and neighbourhood selections using the filters provided on the respective dashboards.',
      primaryDefaultCity: 'Primary Default City',
      secondaryDefaultCity: 'Secondary Default City',
      defaultNeighbourhoodFsa1: 'Default Neighbourhood FSA #1',
      defaultNeighbourhoodFsa2: 'Default Neighbourhood FSA #2',
      toastSavedTitle: 'Changes Saved!',
      toastSavedMessage: 'Market Insights Default Settings are successfully updated.',
    },
    citiesList: {
      addCities: '+ Add Cities',
      addCitiesModalTitle: 'Add Cities',
      confirm: 'Confirm',
      defaultPrimaryCityTooltip: 'Default primary city',
      defaultSecondaryCityTooltip: 'Default secondary city',
      minSubscriptionDurationTooltip: 'Subscription duration must be a minimum of 4 months.',
      setDefaultCities: 'Set Default Cities',
      subId: 'Sub ID',
      tier: 'Tier',
    },
    citySubEditor: {
      modalTitle: 'Add Market Insights Subscriptions',
      startDate: 'Start Date',
      endDate: 'End Date',
      discount: 'Discount',
      discountRangeError: 'Discount can only be between 0 and 100!',
      cannotRemoveExisting: 'Cannot remove an existing subscription on this editor!',
      addSubscription: '+ Add Subscription',
      lastSubEndDateRequired: 'City\'s last sub end date must be defined before adding another sub',
      savingSubscriptions: 'Saving subscriptions...',
      subscriptionsSaved: 'City subscriptions saved!',
      errorSavingSubscriptions: 'There was an error saving subscriptions!',
    },
    learnMoreModal: {
      title: 'Market Insights Filters',
      subCitiesIntro: 'Cities marked with an asterisk include surrounding sub-cities, for example -',
      torontoIncludes: 'includes North York, Scarborough, Etobicoke, and East York',
      ottawaIncludes: 'includes Nepean, Gloucester, and Kanata',
      montrealIncludes: 'includes Saint Laurent, Verdun, Lachine, LaSalle, Cote Saint-Luc, Pointe-Claire, Outremont, and Westmount, Mount-Royal',
      defaultCityDescription: 'The default \'City\' is set based on your portfolio settings. You can change the selections by using the \'City\' filter.',
      defaultCityNeighbourhoodDescription: 'The default \'City\' and \'Neighbourhood FSA\' are set based on your portfolio settings. You can change the selections by using the \'City\' and \'Neighbourhood FSA\' filter.',
      fsaExplanation: 'Neighbourhood FSAs are defined using FSA (Forward Sortation Area) for consistency and accuracy of data. FSA is represented by the first three characters of the postal code.',
      fsaSelectInstructions: 'First select the Cities and then choose the respective Neighborhood FSAs for which you wish to see the data.',
      contactSupport: 'If you would like to change the default settings, please reach out to your account admin or Rentsync support.',
      dashboardsCreatedUsing: 'These dashboards have been created using Rentsync and Rental Listings data.',
      generalDataExplanationTitle: 'General data explanation:',
      generalDataExplanation: 'The data included within the dashboard is sourced from the Rentals.ca network of rental listing sites and Rentsync. Data is deduplicated across sources when identified. Outlier rental rates are similarly removed at the unit type level to account for substantially over-priced, or under-priced units, and miss-labeled accommodations. Only multi-family and single-family property types are considered, this includes the following: single-family, townhouse, apartment, condominium, multiplex, basement apartment, and main-floor apartment.',
      widgetDataTitle: 'Data Associated with Widgets',
      avgRentLabel: 'Avg Rent:',
      avgRentExplanation: 'The total average rent reflects all active listings for the current month for the active market. Outliers are removed at the unit level based on approved rent ranges.',
      avgSquareFootLabel: 'Avg Square foot & Avg Rent per Sqft:',
      avgSquareFootExplanation: 'Dashboards which use square footage have Null and 0 values removed. Similarly, listings with square foot values below 300, and greater than 5,000 are removed to account for outliers.',
      disclaimer: 'Disclaimer: All data presented within the reports is produced from available unit data which may result in variability and inconsistencies within time series data comparisons. The data shown is not reflective of average market rents and is instead reflective of the average of available units within any given period of time.',
    },
    citiesInformationModal: {
      title: 'Learn More - Cities',
      buttonText: 'Got It!',
      subCitiesIntro: 'Cities marked with an asterisk include surrounding sub-cities, for example -',
      torontoIncludes: 'includes North York, Scarborough, Etobicoke, and East York',
      ottawaIncludes: 'includes Nepean, Gloucester, and Kanata',
      montrealIncludes: 'includes Saint Laurent, Verdun, Lachine, LaSalle, Côte Saint-Luc, Pointe-Claire, Outremont, and Westmount, Mount-Royal',
    },
    cityStatusModal: {
      title: 'City Status',
      buttonText: 'Okay',
      activeStatus: 'City subscription is active',
      expiredStatus: 'City subscription has expired',
    },
    reactivateSubscriptionModal: {
      title: 'Reactivate Subscription',
      buttonText: 'Reactivate',
      description: 'Reactivate the subscription by selecting a new start and end month. Minimum subscription duration is 4 months.',
      city: 'City:',
      tier: 'Tier:',
      startMonth: 'Start Month',
      endMonth: 'End Month',
    },
    customReportingModal: {
      title: 'Request Custom Reports',
      buttonText: 'Got it!',
      leadReport: 'Lead Report',
      rentersInsightReport: 'Renters Insight Report',
      marketSurveyReport: 'Market Survey Report',
      marketComparisonReport: 'Market Comparison Report',
      fullCustomReport: 'Full Custom Report',
      imageDisclaimer: 'Disclaimer: Report images showcased are examples and not inclusive of what will be received in the full reports',
      reportDetails: {
        common: {
          averageRentPerMarketAndBedroomCount: 'Average rent per market & per bdrm count',
          averageSqFtByMarketAndBedroomCount: 'Average sq ft by market & by bdrm count',
          averageRentOverTime: 'Average rent over time',
        },
        leadReport: {
          totalLeadsGenerated: 'Total leads generated',
          leadsGeneratedBySource: 'Leads generated by source',
          leadBreakdownByType: 'Lead breakdown by type (phone & email)',
          averageLeadsPerBuilding: 'Average leads per building',
        },
        rentersInsightReport: {
          topSearchedAmenities: 'Top searched amenities',
          topSearchedPropertyUnitTypes: 'Top searched property & unit types',
          ageDistributionOfRenters: 'Age distribution of renters searching',
          breakdownOfTopGeographicalSearches: 'Breakdown of top geographical rental searches',
          breakdownOfRenterProspectLocations: 'Breakdown of renter prospect current locations',
          ga4TrafficData: 'GA4 traffic data for rental listing site',
          breakdownOfRentalRatesWithinSearches: 'Breakdown of rental rates within searches',
        },
        marketSurveyReport: {
          breakdownOfAvgSqFtByBedroomCount: 'Breakdown of avg sq ft by bdrm count',
          breakdownOfAgeOfConstruction: 'Breakdown of age of construction (*select markets only)',
          selectionOfOneSubmarket: 'Selection of 1 submarket',
        },
        marketComparisonReport: {
          selectionOfUpToFourSubmarkets: 'Selection of up to 4 submarkets',
        },
        fullCustomReport: {
          customMetricsAvailable: 'Custom metrics available by request',
          submitRequestToSpeak: 'Submit a request to speak to our Product Manager - Data Services for more information and a quote',
        },
      },
    },
    reportRequestForm: {
      titleSubmitted: 'Report Request Submitted',
      titleDefault: 'Request a Custom Report',
      closeButton: 'Close',
      subscriptionNote: 'Please note that the additional custom reports are not included within your Market Insights subscription. They are available at an additional cost. Once submitted you will be contacted by a Rentsync team member with the next steps.',
      leadReportDescription: 'Aggregated view of lead volumes and lead generation by source for a specified geography',
      rentersInsightReportDescription: 'Renter behavioural insights based on their online apartment searches',
      customReportDescription: 'Custom requests and data analysis tailored to your individual needs',
      footerSubmissionNote: 'Once submitted you will be contacted by a Rentsync team member with the next steps.',
      footerPaymentNote: 'All reports are available for purchase and the report will be emailed to you once the payment is made. Eligibility terms and conditions apply. Please contact your Rentsync Account Manager for more information.',
    },
  },
} as const;

export const marketInsightsFr = {
  marketInsights: {
    nav: {
      citiesList: 'Listes des villes',
      customReporting: 'Rapports personnalisés',
      defaultSettings: 'Paramètres par défaut',
      historicalMarketData: 'Données historiques du marché',
      marketComparisonCity: 'Comparaison de marché (Ville)',
      marketComparisonNeighbourhood: 'Comparaison de marché (Quartier FSA)',
      marketData: 'Données du marché',
      portfolioComparison: 'Comparaison de portefeuille',
      settings: 'Paramètres',
      title: 'Aperçus du marché',
    },
    filters: {
      fsaBasedOnCity: 'FSA - Selon la ville sélectionnée',
      fsaMap: {
        mapView: 'Vue de la carte',
        checkboxList: 'Liste à cocher',
        loadingFsaBoundaries: 'Chargement des limites des FSA...',
        noFsaBoundaryData: 'Aucune donnée de limites de FSA disponible pour cette ville.',
        failedToLoadFsaBoundaryData: 'Échec du chargement des données de limites de FSA.',
        legendAvailable: 'Disponible',
        legendSelected: 'Sélectionné',
      },
      labels: {
        city: 'Ville',
        fsa: 'FSA',
        neighbourhoodFsas: 'FSA de quartier',
        province: 'Province',
        propertyType: 'Type de propriété',
        bedrooms: 'Chambres',
        amenities: 'Commodités',
        utilities: 'Services publics',
        ageOfConstruction: 'Âge de construction',
        numberOfStories: 'Nombre d\'étages',
        parkingAvailable: 'Stationnement disponible',
        parkingIncluded: 'Stationnement inclus',
        parkingType: 'Type de stationnement',
        pets: 'Animaux',
        timelineRange: 'Plage de temps',
        properties: 'Propriétés',
      },
      helpText: {
        singleCityScope: 'Sélectionnez une seule ville pour cibler la comparaison des aperçus du marché.',
        upToFourCities: 'Choisissez jusqu\'à quatre villes à comparer dans ce rapport.',
        ageOfConstructionAvailability: 'Le filtre Âge de construction est sujet à la disponibilité selon les propriétés recensées dans chaque marché',
        numberOfStoriesAvailability: 'Le filtre Nombre d\'étages est sujet à la disponibilité selon les propriétés recensées dans chaque marché. Les tours sont désignées comme ayant 13 étages ou plus, les immeubles de hauteur moyenne de 5 à 12 étages, et les immeubles de faible hauteur de 0 à 4 étages',
        parkingAvailability: 'Les données proviennent uniquement des annonces où l\'information sur le stationnement est disponible.',
      },
      headingGroups: {
        portfolioAndMarket: 'Portefeuille et marché',
        portfolioOnly: 'Portefeuille seulement',
        marketOnly: 'Marché seulement',
      },
      dateOptions: {
        currentMonth: 'Mois en cours',
        last24Months: '24 derniers mois',
        last18Months: '18 derniers mois',
        last12Months: '12 derniers mois',
        last6Months: '6 derniers mois',
      },
      ageOfConstruction: {
        post2010: 'Après 2010',
        pre2010: 'Avant 2010',
      },
      numberOfStories: {
        highRise: 'Tour de grande hauteur',
        midRise: 'Immeuble de hauteur moyenne',
        lowRise: 'Immeuble de faible hauteur',
      },
      parkingAvailable: {
        available: 'Stationnement disponible',
        unavailable: 'Stationnement non disponible',
      },
      parkingIncluded: {
        included: 'Stationnement inclus',
        notIncluded: 'Stationnement non inclus',
      },
      parkingType: {
        driveway: 'Entrée de cour',
        electric: 'Électrique',
        garage: 'Garage',
        indoor: 'Intérieur',
        outdoor: 'Extérieur',
        underground: 'Souterrain',
        valet: 'Voiturier',
      },
      propertyTypes: {
        apartment: 'Appartement',
        basement: 'Sous-sol',
        condo: 'Condo',
        house: 'Maison',
        mainFloor: 'Rez-de-chaussée',
        multiplex: 'Multiplex',
        townhouse: 'Maison en rangée',
      },
      utilities: {
        electricity: 'Électricité',
        heat: 'Chauffage',
        water: 'Eau',
      },
      petFriendlyTypes: {
        allowed: 'Animaux acceptés',
        refused: 'Animaux refusés',
      },
    },
    banners: {
      customReportMessage: 'Obtenez plus d\'aperçus grâce à nos rapports personnalisés supplémentaires, conçus sur mesure pour répondre aux besoins de votre entreprise.',
      expiredSubsHidden: 'Les abonnements expirés ne sont pas affichés.',
      lookingForMoreCities: 'Vous cherchez plus de villes ou de marchés locatifs ? Communiquez avec votre gestionnaire de compte Rentsync.',
      noMarketDataWarning: 'Nous n\'avons actuellement aucune donnée de marché pour les marchés suivants auxquels vous êtes abonné : {markets}.',
      portfolioComparisonAccessMessage: 'Vous avez actuellement accès uniquement aux aperçus de marché de la Comparaison de portefeuille, puisque vous avez des annonces promues. Débloquez des données plus détaillées, des filtres avancés et des rapports supplémentaires grâce à l\'accès complet.',
      provincialAccessMessage: 'Vous avez actuellement accès uniquement aux aperçus de marché au niveau provincial. Débloquez les données au niveau des villes, des filtres avancés et des rapports supplémentaires grâce à l\'accès complet.',
      requestFullAccess: 'Demander l\'accès complet',
      requestReport: 'Demander un rapport',
      setupClientCitiesReminder: 'Lors de la configuration d\'un client, veuillez ajouter la liste des villes demandées.',
      subCitiesAsterisk: 'Les villes marquées d\'un astérisque comprennent les villes environnantes.',
      wantMoreInsights: 'Vous voulez plus d\'aperçus ?',
    },
    availableFilters: 'Filtres disponibles',
    learnMoreLink: 'En savoir plus sur les données',
    marketData: {
      title: 'Données du marché',
      description: 'Ce rapport fournit des aperçus de marché sur le loyer moyen, la superficie moyenne, le loyer moyen par pied carré, le volume d\'annonces, les commodités les plus fréquemment annoncées, la répartition des loyers, la répartition des superficies et la répartition du loyer par pied carré pour les annonces actives du mois en cours.',
      filtersDescription: 'Sélectionnez une province, une ville, des FSA, un mois, des types de propriété, des commodités, des services publics, la disponibilité du stationnement et la politique relative aux animaux pour afficher les aperçus souhaités.',
    },
    historicalMarketData: {
      title: 'Données historiques du marché',
      description: 'Ce rapport fournit des aperçus historiques sur le loyer moyen, la superficie moyenne, le loyer moyen par pied carré et le volume d\'annonces au fil du temps.',
      filtersDescription: 'Sélectionnez une ville, des types de propriété, l\'âge de construction et le nombre d\'étages pour afficher les aperçus souhaités.',
    },
    portfolioComparison: {
      title: 'Comparaison de portefeuille',
      description: 'Ce rapport compare vos annonces actives aux annonces actives du marché et fournit des aperçus sur le loyer moyen, la superficie moyenne et le loyer moyen par pied carré.',
      filtersDescription: 'Sélectionnez une ville, des FSA, des types de propriété, vos propriétés, l\'âge de construction et le nombre d\'étages pour afficher les aperçus souhaités.',
    },
    infinityPortfolioComparison: {
      title: 'Comparaison de portefeuille',
      filtersDescription: 'Sélectionnez une ville, des FSA, des types de propriété et vos propriétés pour afficher les aperçus souhaités.',
    },
    jaqlFilters: {
      clientsCities: 'Villes des clients',
      clientsBedrooms: 'Chambres des clients',
    },
    marketComparisonCity: {
      title: 'Comparaison de marché (Ville)',
      description: 'Ce rapport compare les données des annonces actives entre les marchés et fournit des aperçus sur le loyer moyen, la superficie moyenne et le volume d\'annonces.',
      filtersDescription: 'Sélectionnez deux villes ou plus (jusqu\'à 4) pour afficher les aperçus souhaités.',
    },
    marketComparisonNeighbourhood: {
      title: 'Comparaison de marché (Quartier FSA)',
      description: 'Ce rapport compare les données des annonces actives entre les quartiers et fournit des aperçus sur le loyer moyen, la superficie moyenne et le volume d\'annonces. Les quartiers sont définis selon le FSA, soit les trois premiers caractères d\'un code postal.',
      filtersDescription: 'Sélectionnez deux quartiers ou plus (jusqu\'à 4) pour afficher les aperçus souhaités.',
    },
    defaultSettings: {
      header: 'Paramètres par défaut',
      description: 'Choisissez la ville et le quartier par défaut pour les données par défaut des tableaux de bord Aperçus du marché.',
      descriptionNote: 'Ceci ne fait que définir les données par défaut; vous pourrez ensuite modifier les sélections de ville et de quartier à l\'aide des filtres fournis sur les tableaux de bord respectifs.',
      primaryDefaultCity: 'Ville par défaut principale',
      secondaryDefaultCity: 'Ville par défaut secondaire',
      defaultNeighbourhoodFsa1: 'Quartier FSA par défaut no 1',
      defaultNeighbourhoodFsa2: 'Quartier FSA par défaut no 2',
      toastSavedTitle: 'Modifications enregistrées !',
      toastSavedMessage: 'Les paramètres par défaut des aperçus du marché ont été mis à jour avec succès.',
    },
    citiesList: {
      addCities: '+ Ajouter des villes',
      addCitiesModalTitle: 'Ajouter des villes',
      confirm: 'Confirmer',
      defaultPrimaryCityTooltip: 'Ville principale par défaut',
      defaultSecondaryCityTooltip: 'Ville secondaire par défaut',
      minSubscriptionDurationTooltip: 'La durée de l\'abonnement doit être d\'au moins 4 mois.',
      setDefaultCities: 'Définir les villes par défaut',
      subId: 'N° d\'abonnement',
      tier: 'Palier',
    },
    citySubEditor: {
      modalTitle: 'Ajouter des abonnements aux aperçus du marché',
      startDate: 'Date de début',
      endDate: 'Date de fin',
      discount: 'Rabais',
      discountRangeError: 'Le rabais doit être compris entre 0 et 100 !',
      cannotRemoveExisting: 'Impossible de retirer un abonnement existant à partir de cet éditeur !',
      addSubscription: '+ Ajouter un abonnement',
      lastSubEndDateRequired: 'La date de fin du dernier abonnement de la ville doit être définie avant d\'en ajouter un autre',
      savingSubscriptions: 'Enregistrement des abonnements...',
      subscriptionsSaved: 'Abonnements des villes enregistrés !',
      errorSavingSubscriptions: 'Une erreur est survenue lors de l\'enregistrement des abonnements !',
    },
    learnMoreModal: {
      title: 'Filtres des aperçus du marché',
      subCitiesIntro: 'Les villes marquées d\'un astérisque comprennent les villes environnantes, par exemple :',
      torontoIncludes: 'comprend North York, Scarborough, Etobicoke et East York',
      ottawaIncludes: 'comprend Nepean, Gloucester et Kanata',
      montrealIncludes: 'comprend Saint-Laurent, Verdun, Lachine, LaSalle, Côte-Saint-Luc, Pointe-Claire, Outremont, Westmount et Mont-Royal',
      defaultCityDescription: 'La \'ville\' par défaut est définie selon les paramètres de votre portefeuille. Vous pouvez modifier la sélection à l\'aide du filtre \'Ville\'.',
      defaultCityNeighbourhoodDescription: 'La \'ville\' et le \'quartier FSA\' par défaut sont définis selon les paramètres de votre portefeuille. Vous pouvez modifier les sélections à l\'aide des filtres \'Ville\' et \'Quartier FSA\'.',
      fsaExplanation: 'Les quartiers FSA sont définis à l\'aide du FSA (région de tri d\'acheminement) afin d\'assurer la cohérence et l\'exactitude des données. Le FSA correspond aux trois premiers caractères du code postal.',
      fsaSelectInstructions: 'Sélectionnez d\'abord les villes, puis choisissez les quartiers FSA respectifs pour lesquels vous souhaitez consulter les données.',
      contactSupport: 'Si vous souhaitez modifier les paramètres par défaut, veuillez communiquer avec l\'administrateur de votre compte ou le soutien Rentsync.',
      dashboardsCreatedUsing: 'Ces tableaux de bord ont été créés à partir des données de Rentsync et des annonces locatives.',
      generalDataExplanationTitle: 'Explication générale des données :',
      generalDataExplanation: 'Les données incluses dans le tableau de bord proviennent du réseau de sites d\'annonces locatives Rentals.ca et de Rentsync. Les données sont dédupliquées entre les sources lorsqu\'elles sont détectées. Les loyers aberrants sont également retirés au niveau du type d\'unité afin de tenir compte des unités nettement surévaluées ou sous-évaluées, ainsi que des logements mal étiquetés. Seuls les types de propriété multifamiliale et unifamiliale sont considérés, ce qui comprend : unifamiliale, maison en rangée, appartement, condominium, multiplex, appartement au sous-sol et appartement au rez-de-chaussée.',
      widgetDataTitle: 'Données associées aux widgets',
      avgRentLabel: 'Loyer moyen :',
      avgRentExplanation: 'Le loyer moyen total reflète toutes les annonces actives du mois en cours pour le marché actif. Les valeurs aberrantes sont retirées au niveau de l\'unité selon les fourchettes de loyer approuvées.',
      avgSquareFootLabel: 'Superficie moyenne et loyer moyen par pied carré :',
      avgSquareFootExplanation: 'Les tableaux de bord qui utilisent la superficie excluent les valeurs nulles et les valeurs à 0. De même, les annonces dont la superficie est inférieure à 300 pieds carrés ou supérieure à 5 000 pieds carrés sont exclues afin de tenir compte des valeurs aberrantes.',
      disclaimer: 'Avis : Toutes les données présentées dans les rapports sont produites à partir des données d\'unités disponibles, ce qui peut entraîner une certaine variabilité et des incohérences dans les comparaisons de séries chronologiques. Les données affichées ne reflètent pas le loyer moyen du marché, mais plutôt la moyenne des unités disponibles au cours d\'une période donnée.',
    },
    citiesInformationModal: {
      title: 'En savoir plus – Villes',
      buttonText: 'Compris !',
      subCitiesIntro: 'Les villes marquées d\'un astérisque comprennent les villes environnantes, par exemple :',
      torontoIncludes: 'comprend North York, Scarborough, Etobicoke et East York',
      ottawaIncludes: 'comprend Nepean, Gloucester et Kanata',
      montrealIncludes: 'comprend Saint-Laurent, Verdun, Lachine, LaSalle, Côte-Saint-Luc, Pointe-Claire, Outremont, Westmount et Mont-Royal',
    },
    cityStatusModal: {
      title: 'Statut de la ville',
      buttonText: 'D\'accord',
      activeStatus: 'L\'abonnement de la ville est actif',
      expiredStatus: 'L\'abonnement de la ville a expiré',
    },
    reactivateSubscriptionModal: {
      title: 'Réactiver l\'abonnement',
      buttonText: 'Réactiver',
      description: 'Réactivez l\'abonnement en sélectionnant un nouveau mois de début et de fin. La durée minimale de l\'abonnement est de 4 mois.',
      city: 'Ville :',
      tier: 'Palier :',
      startMonth: 'Mois de début',
      endMonth: 'Mois de fin',
    },
    customReportingModal: {
      title: 'Demander des rapports personnalisés',
      buttonText: 'Compris !',
      leadReport: 'Rapport sur les prospects',
      rentersInsightReport: 'Rapport d\'analyse des comportements des locataires',
      marketSurveyReport: 'Rapport d\'étude de marché',
      marketComparisonReport: 'Rapport de comparaison de marché',
      fullCustomReport: 'Rapport personnalisé complet',
      imageDisclaimer: 'Avis : Les images de rapport présentées sont des exemples et ne représentent pas l\'ensemble du contenu des rapports complets',
      reportDetails: {
        common: {
          averageRentPerMarketAndBedroomCount: 'Loyer moyen par marché et par nombre de chambres',
          averageSqFtByMarketAndBedroomCount: 'Superficie moyenne par marché et par nombre de chambres',
          averageRentOverTime: 'Loyer moyen au fil du temps',
        },
        leadReport: {
          totalLeadsGenerated: 'Total des prospects générés',
          leadsGeneratedBySource: 'Prospects générés par source',
          leadBreakdownByType: 'Répartition des prospects par type (téléphone et courriel)',
          averageLeadsPerBuilding: 'Moyenne de prospects par immeuble',
        },
        rentersInsightReport: {
          topSearchedAmenities: 'Commodités les plus recherchées',
          topSearchedPropertyUnitTypes: 'Types de propriété et d\'unité les plus recherchés',
          ageDistributionOfRenters: 'Répartition par âge des locataires effectuant des recherches',
          breakdownOfTopGeographicalSearches: 'Répartition des principales recherches de location par région géographique',
          breakdownOfRenterProspectLocations: 'Répartition des emplacements actuels des locataires potentiels',
          ga4TrafficData: 'Données de trafic GA4 pour le site d\'annonces locatives',
          breakdownOfRentalRatesWithinSearches: 'Répartition des taux de location dans les recherches',
        },
        marketSurveyReport: {
          breakdownOfAvgSqFtByBedroomCount: 'Répartition de la superficie moyenne par nombre de chambres',
          breakdownOfAgeOfConstruction: 'Répartition de l\'âge de construction (*certains marchés seulement)',
          selectionOfOneSubmarket: 'Sélection d\'un sous-marché',
        },
        marketComparisonReport: {
          selectionOfUpToFourSubmarkets: 'Sélection de jusqu\'à 4 sous-marchés',
        },
        fullCustomReport: {
          customMetricsAvailable: 'Indicateurs personnalisés disponibles sur demande',
          submitRequestToSpeak: 'Soumettez une demande pour discuter avec notre gestionnaire de produits - Services de données, pour plus d\'informations et pour obtenir une soumission',
        },
      },
    },
    reportRequestForm: {
      titleSubmitted: 'Demande de rapport soumise',
      titleDefault: 'Demander un rapport personnalisé',
      closeButton: 'Fermer',
      subscriptionNote: 'Veuillez noter que les rapports personnalisés supplémentaires ne sont pas inclus dans votre abonnement aux aperçus du marché. Ils sont offerts à un coût additionnel. Une fois la demande soumise, un membre de l\'équipe Rentsync communiquera avec vous pour connaître les prochaines étapes.',
      leadReportDescription: 'Vue agrégée des volumes de prospects et de la génération de prospects par source pour une zone géographique donnée',
      rentersInsightReportDescription: 'Aperçus comportementaux des locataires basés sur leurs recherches d\'appartements en ligne',
      customReportDescription: 'Demandes personnalisées et analyses de données adaptées à vos besoins particuliers',
      footerSubmissionNote: 'Une fois la demande soumise, un membre de l\'équipe Rentsync communiquera avec vous pour connaître les prochaines étapes.',
      footerPaymentNote: 'Tous les rapports sont offerts à l\'achat et le rapport vous sera envoyé par courriel une fois le paiement effectué. Des modalités d\'admissibilité s\'appliquent. Veuillez contacter votre gestionnaire de compte Rentsync pour plus d\'informations.',
    },
  },
} as const;
